import { render, staticRenderFns } from "./HomeBenefits.vue?vue&type=template&id=b4c144d4"
import script from "./HomeBenefits.vue?vue&type=script&lang=js"
export * from "./HomeBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports